// import { schema, normalize } from 'normalizr';
import { fetchData } from '../api/api-helpers';
const GETDEPARTMENT_URL = '/v1.0/me?$select=department';
const RESOURCE_NAME_GRAPH = 'Graph';

export async function getDepartment() {
  return fetchData(GETDEPARTMENT_URL, RESOURCE_NAME_GRAPH);
}

